import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { formatPhoneNumber } from 'src/app/utils/format-phone-number';

export interface IContactFormsState {
  name: string;
  email: string;
  phone: string;
  notes: string;
}

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  @Input() data: IContactFormsState;
  @Output() value: EventEmitter<IContactFormsState> =
    new EventEmitter<IContactFormsState>();

  datalocal: IContactFormsState;

  constructor() {}

  ngOnInit(): void {
    this.datalocal = { ...this.data };
  }

  getKey(): string {
    return 'componente_' + Math.random().toString(36).substring(7);
  }

  sendValue(): void {
    this.datalocal.phone = formatPhoneNumber(this.datalocal.phone)
    this.value.emit(this.datalocal);
  }
}
